<template>
  <VSection title="배달정보" :padding="[25, 15, 5, 15]" :useUnderline="false">
    <VBlock class="contents-wrapper" :direction="Direction.column" :padding="[15, 15, 20, 15]">
      <VBlock
        class="address-text-wrapper"
        :direction="Direction.column"
        :sort="Sort.left_center"
        :margin="[0, 0, 20, 0]"
      >
        <VP
          class="address-text top-text"
          :text="delivery.address || ''"
          :size="20"
          :weight="TextWeight.bold"
          :spacing="-0.47"
          :color="TextColor.darkGray"
        />
        <VP
          class="address-text"
          :text="`[도로명] ${delivery.roadAddress}`"
          :size="16"
          :spacing="-0.38"
          :color="TextColor.darkGray"
        />
      </VBlock>
      <VBlock :margin="[0, 0, 8, 0]">
        <!-- TODO check src/components/order/DeliveryAddress.vue:18 -->
        <VInput
          :marginZero="true"
          id="detail-address"
          :value="deliveryDetailAddress"
          :onChanged="(event) => { onChangeDelivery({ detailAddress: event.target.value }) }"
          :maxlength="35"
          placeholder="상세주소를 입력하세요 (건물명, 동/호수 등)"
          errorMessage="상세주소를 입력하세요"
          :isValidate="validateDeliveryDetailAddress(delivery.detailAddress)"
        />
      </VBlock>
      <VBlock :margin="[0, 0, 6, 0]">
        <!-- TODO check src/components/order/MobileNumber.vue:8 -->
        <!-- Validate 걸어야함. 로그인 되어있는지 아닌지 파악.-->
        <!-- TODO 전화번호 포맷팅 check src/presentationals/v1/components/order/MobileNumber.vue:64 -->
        <VInput
          id="phone-number"
          :value="deliveryPhoneNumber"
          :onChanged="(event) => { onChangeDelivery({ phoneNumber: event.target.value }) }"
          :maxlength="11"
          placeholder="휴대폰번호를 입력하세요"
          errorMessage="올바른 번호를 입력하세요"
          :isValidate="validatePhoneNumber(delivery.phoneNumber)"
          :isDisable="isSign"
        />
      </VBlock>
      <VBlock class="safety-wrapper" :sort="Sort.space_between" :margin="[0, 0, 20, 0]">
        <!-- TODO check src/components/order/SafeNumber.vue:5 -->
        <VBlock class="safety" v-if="isSign" :sort="Sort.left_center">
          <VCheckBox
            name="안심번호 사용"
            :checked="delivery.useSafePhoneNumber"
            :onChecked="() => { onCheckedUseSafePhoneNumber() }"
          >
            <VSpan class="text" text="안심번호 사용" :size="14" />
          </VCheckBox>
        </VBlock>
        <VBlock class="safety" v-else :padding="[0, 0, 0, 12]" :sort="Sort.left_center">
          <VSpan text="로그인 시 안심번호 사용가능" :color="TextColor.gray2" :size="14" />
        </VBlock>
        <VA :onClick="onSafePhoneNumberInformation">
          <VSpan class="text" text="안심번호란?" :color="TextColor.gray2" :size="14" />
        </VA>
      </VBlock>
      <VBlock :direction="Direction.column" :sort="Sort.left_center" :margin="[0, 0, 20, 0]">
        <VBlock :sort="Sort.left_center" :margin="[0, 0, 6, 0]">
          <VInput
            id="user-email"
            :value="userEmail"
            :onChanged="(event) => { onChangeUserEmail(event.target.value) }"
            :maxlength="40"
            placeholder="example@woowahan.com"
            :errorMessage="errorMessageUserEmail"
            :isValidate="isValidateUserEmail"
            :isDisable="isSign"
          />
        </VBlock>
        <VBlock :sort="Sort.left_center" :padding="[0, 0, 0, 12]">
          <VSpan text="주문 내용을 해당 메일로 발송해드립니다" :color="TextColor.gray2" :size="14" />
        </VBlock>
      </VBlock>
      <VHR v-if="isProvideDeliveryReservation" :color="LineColor.gray2" />
    </VBlock>
  </VSection>
</template>

<script>
import VBlock, { Direction, Sort } from '../../molecules/VBlock'
import VSection from '../../molecules/VSection'
import VCard, { ColorType } from '../../molecules/VCard'
import VP, { TextWeight, TextColor } from '../../atoms/VP'
import VInput from '../../atoms/VInput/index'
import VCheckBox from '../../atoms/VCheckBox/index'
import VSpan from '../../atoms/VSpan'
import VHR, { LineColor } from '@/presentationals/v2/components/layouts/atoms/VHR'
import {
  validateDeliveryDetailAddress,
  validatePhoneNumber,
  validateUserEmail
} from '@/models/PreOrder/OrderRequest'
import VA from '../../molecules/VA/index'

export default {
  name: 'PreOrderDelivery',
  components: { VA, VSpan, VCheckBox, VInput, VP, VCard, VSection, VBlock, VHR },
  props: {
    isProvideDeliveryReservation: {
      type: Boolean,
      required: true
    },
    delivery: {
      type: Object,
      required: true
    },
    userEmail: {
      type: String,
      required: true
    },
    deliveryDetailAddress: {
      type: String,
      default: ''
    },
    deliveryPhoneNumber: {
      type: String,
      default: ''
    },
    isSign: {
      type: Boolean,
      required: true
    },
    onChangeDelivery: {
      type: Function,
      required: true
    },
    onCheckedUseSafePhoneNumber: {
      type: Function,
      required: true
    },
    onSafePhoneNumberInformation: {
      type: Function,
      required: true
    },
    onChangeUserEmail: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      Direction,
      Sort,
      ColorType,
      TextWeight,
      TextColor,
      LineColor
    }
  },
  computed: {
    isValidateUserEmail() {
      const valid = validateUserEmail(this.userEmail)

      return typeof valid === 'boolean' && valid === true
    },
    errorMessageUserEmail() {
      const valid = validateUserEmail(this.userEmail)

      return typeof valid === 'string' ? valid : null
    }
  },
  methods: {
    validateDeliveryDetailAddress,
    validatePhoneNumber,
    validateUserEmail
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.contents-wrapper {
  width: 100%;
  // padding: 15px 16px 20px 16px;

  .address-text-wrapper {
    .address-text {
      text-align: left;
    }

    .top-text {
      margin-bottom: 4px;
    }
  }

  /* .address-wrapper {
    margin-bottom: 8px;
  }

  .phone-wrapper {
    margin-bottom: 4px;
  } */

  .safety-wrapper {
    align-items: center;

    .safety {
      width: auto;
      height: auto;

      .text {
        font-size: 14px !important;
      }
    }
  }
}
</style>
